const SERVICE_IDS = new Set(['outlineLayer', 'captionLayer']);
const SERVICE_CLASSES = new Set(['Transformer']);

export function prepareStageJson(stage) {
  const stageObj = JSON.parse(stage.toJSON());

  stageObj.children = stageObj.children
    .filter((layer) => !SERVICE_IDS.has(layer.attrs?.id))
    .map((layer) => ({
      ...layer,
      children: (layer.children ?? [])
        .filter(
          (child) =>
            !SERVICE_CLASSES.has(child.className) &&
            child.attrs?.id !== 'selectionRectangle' &&
            child.attrs?.name !== 'measure-overlay',
        )
        .map((child) => {
          if (child.attrs?.id === 'canvas_bg') {
            const { stroke, strokeWidth, ...rest } = child.attrs;
            return { ...child, attrs: rest };
          }
          return child;
        }),
    }));

  return stageObj;
}

export function ensureDefaultFonts(stage) {
  stage.find('Text').forEach((t) => {
    if (!t.attrs.fontFamily) t.setAttr('defaultFontFamily', 'Arial');
  });
}
